/**
 * Quote status levels as returned by the LTL Quoting API in
 * `QuoteResponse.statusLevel`. Mirrors the backend `QuoteStatus` enum.
 */
export const QuoteStatus = {
	QuoteDetails: 1,
	CarrierSelection: 2,
	ShipmentDetails: 3,
	PaymentRequired: 4,
	Tendered: 5,
	Rerating: 6,
	Requote: 7,
	Review: 8,
} as const;

export type QuoteStatusValue = (typeof QuoteStatus)[keyof typeof QuoteStatus];
